// extracted by mini-css-extract-plugin
export default {"quizSelector":"quizSelector_quizSelector__p-HGx"};